module.exports = __webpack_public_path__ + "static/img/banner_yellow.130f4d34.png";